<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <!-- post anewitem / stage one -->
        <app-stage-one v-if="stage1"></app-stage-one>
        
        <!-- post anewitem / stage two -->
        <app-stage-two v-if="stage2"></app-stage-two>
        
        <!-- post anewitem / stage three -->
        <app-stage-three v-if="stage3"></app-stage-three>
        
        <!-- post anewitem / review post -->
        <app-review-post v-if="review"></app-review-post>
    </div>
</template>

<script>
import { eventBus } from '@/main'

import Account from '../shared/Account.vue'
import StageOne from './anewitemStages/StageOne.vue'
import StageTwo from './anewitemStages/StageTwo.vue'
import StageThree from './anewitemStages/StageThree.vue'
import ReviewPost from './anewitemStages/ReviewPost.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "PostItem",
    data() {
        return {
            stage1: true,
            stage2: false,
            stage3: false,
            review: false
        }
    },
    components: {
        appAccount: Account,
        appStageOne: StageOne,
        appStageTwo: StageTwo,
        appStageThree: StageThree,
        appReviewPost: ReviewPost
    },
    created() {
        eventBus.$on('gotoStage1', (val) => {
            this.stage2 = this.stage3 = this.review = !val
            this.stage1 = val
        }),
        eventBus.$on('gotoStage2', (val) => {
            this.stage1 = this.stage3 = this.review = !val
            this.stage2 = val;
        }),
        eventBus.$on('gotoStage3', (val) => {
            this.stage1 = this.stage2 = this.review = !val
            this.stage3 = val
        }),
        eventBus.$on('gotoReviewPost', (val) => {
            this.stage1 = this.stage2 = this.stage3 = !val
            this.review = val
        }),
        this.$emit('update:layout', LayoutUser);
    }
}
</script>